import type { ReactNode } from "react";
import type { TooltipRenderProps } from "react-joyride";

const KemTourTooltip = ({
  continuous,
  index,
  step,
  backProps,
  closeProps,
  primaryProps,
  tooltipProps,
  isLastStep,
}: TooltipRenderProps) => {
  const showBackButton = index > 0;
  const showFooter = Boolean(showBackButton || continuous);
  const content = (step as { content: ReactNode }).content;

  return (
    <div
      {...tooltipProps}
      className="max-w-[calc(100vw-40px)] rounded-lg bg-white shadow-lg md:max-w-[500px]"
    >
      <div className="max-h-[60vh] overflow-y-auto whitespace-pre-wrap p-4 text-sm leading-relaxed text-ink-900">
        {content}
      </div>
      {showFooter &&
        // prettier-ignore
        <div className="border-gray-150 flex items-stretch gap-0 border-t">
          {showBackButton && (
            <button
              {...backProps}
              className="hover:bg-gray-50 active:bg-gray-100 h-12 flex-1 text-center font-semibold text-ink-900"
              type="button"
            >
              Previous
            </button>
          )}
          {continuous && (
            <button
              {...primaryProps}
              className="hover:bg-gray-50 active:bg-gray-100 h-12 flex-1 text-center font-semibold text-ink-900"
              type="button"
            >
              {isLastStep ? "Finish" : "Next"}
            </button>
          )}
        </div>}
      {/* Hidden close button for accessibility */}
      <button
        {...closeProps}
        aria-label="Close tour"
        className="sr-only"
        type="button"
      >
        Close
      </button>
    </div>
  );
};

export default KemTourTooltip;
